import { useEffect, useContext } from "react";
import Header from "./Header";
import useState from "react-usestateref";
import authservices from "../services/authservices";
import SubFooter from "./SubFooter";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
import './Landing.css';

const Aboutus = () => {
  const [userAuth, setAuth, userAuthref] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    getSitedata();
  }, []);
  const [siteDatacomes, setSiteData] = useState("");

  const getSitedata = async () => {
    try {
      const data = await authservices.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) { }
  };

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <main className="wyscale_landing_main">
        <Header />
      </main>

      <section className="dashboard_content_section">
        <div className="container">
          <div className="smart_dashboard_content" id="terms-condition">
            <h2>{t("AboutUs")}</h2>
            <div className="row">
              <div className="col-lg-12">
                <div className="dash_board_profile_content">
                  <div className="contentpage">
                    {/* <h4>NOTICE:</h4> */}
                    <h3 className="About_us_Heading">{t("BuiltforTradersWhoWantFullControl")}</h3>
                

                    <p>{t("AtBinarge")}</p>

                    <h3>{t("WhyBinargeWasCreated")}</h3>

                    <p>{t("BinargeIsSoftwareBasedCryptocurrency")}</p>
                    <p>{t("ToGiveUpControl")}</p>
                     <h3>{t('WhatWeStandFor')}</h3>
                    <h3>{t("WhatWeStandFor1")}</h3>
                    <ul>
                      <li>{t("Transparency")}</li>
                      <li>{t("Control")}</li>
                      <li>{t("Growth")}</li>
                      <li>{t("SupportWe")}</li>
                    </ul>

                    <h3>{t("Traders")}</h3>
                    <p>{t("BinargeWasCreatedCrypto")} </p>
                    {/* <h3 className="About_us_Heading">{t("BuiltforTradersWhoWantFullControl")}</h3>
                    {/* <p className="about_us_para">{t("AtBinarge")}</p> */}
                    {/* <p >{t("AtBinarge")}</p>
                    <h3>{t("WhyBinargeWasCreated")}</h3>
                    <p>{t("BinargeIsSoftwareBasedCryptocurrency1")}</p>
                    <p>{t("BinargeIsSoftwareBasedCryptocurrency2")}</p>
                    <p>{t("BinargeIsSoftwareBasedCryptocurrency3")}</p>
                    <p >{t("BinargeIsSoftwareBasedCryptocurrency4")}</p>
                    <p>{t("automaticTrading")}</p>
                    <p>{t("automaticTradingAnswer1")}</p>
                    <p>{t("automaticTradingAnswer2")}</p>
                    <h3>{t("WhatWeStandFor")}</h3>
                    <h3>{t("Transparency")}</h3>
                    <p>{t("Transparency_def")}</p>
                    <h3>{t("Control")}</h3>
                    <p>{t("Control_def")}</p>
                    <h3>{t("Growth")}</h3>
                    <p>{t("Growth_def")}</p>
                    <h3 >{t("SupportWe")}</h3>
                    <p>{t("SupportWe_def")}</p>
                    <h3>{t("Traders")}</h3>
                    <p>{t("BinargeWasCreatedCrypto")}</p>
                    <p>{t("BinargeWasCreatedCrypto2")}</p>
                    <p>{t("BinargeWasCreatedCrypto3")}</p> */} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SubFooter />
    </>
  );
};

export default Aboutus;
